import { defineMessages } from 'react-intl';

export default defineMessages({
  borrowedDescription: 'You borrowed this asset',
  depositDescription: 'You deposited this asset',
  APYTypeChangeDescription: 'You have changed your APY Type for your asset',
  repaidDescription: 'You have made a repayment',
  withdrawalDescription: 'You withdrew an asset to an external address',
  usageOfCollateralDescription: 'You have chosen that this asset be used/not be used as collateral',
  liquidationDescription: 'Your position has been liquidated',

  amount: 'Amount',
  liquidationAmount: 'Debt covered',

  date: 'Date',
  asset: 'Asset',
  viewTransaction: 'View Transaction',
  explorer: 'Explorer',
});
